import Events from "./patterns/Events";
import Issues from "./patterns/Issues";
import GroupAnnotations from "./patterns/GroupAnnotations";
import JournalIssues from "./patterns/JournalIssues";
import JournalSummary from "./patterns/JournalSummary";
import JournalSummaryEmpty from "./patterns/JournalSummaryEmpty";
import JournalVolumes from "./patterns/JournalVolumes";
import MyAnnotations from "./patterns/MyAnnotations";
import MyStarred from "./patterns/MyStarred";
import Projects from "./patterns/Projects";
import ProjectsSummary from "./patterns/ProjectsSummary";
import ProjectCollectionDetail from "./patterns/ProjectCollectionDetail";
import ProjectCollectionSummary from "./patterns/ProjectCollectionSummary";
import ProjectResources from "./patterns/ProjectResources";
import ProjectResourceCollectionDetail from "./patterns/ProjectResourceCollectionDetail";
import ProjectResourceCollectionSlideshow from "./patterns/ProjectResourceCollectionSlideshow";
import ProjectResourceCollections from "./patterns/ProjectResourceCollections";
import ReaderFullNotes from "./patterns/ReaderFullNotes";

export default {
  Events,
  Issues,
  GroupAnnotations,
  JournalIssues,
  JournalSummary,
  JournalSummaryEmpty,
  JournalVolumes,
  MyAnnotations,
  MyStarred,
  Projects,
  ProjectsSummary,
  ProjectCollectionDetail,
  ProjectCollectionSummary,
  ProjectResources,
  ProjectResourceCollectionDetail,
  ProjectResourceCollectionSlideshow,
  ProjectResourceCollections,
  ReaderFullNotes
};
